module.exports = __webpack_public_path__ + "img/rich-checked-en.860b6528.png";